// History timeline is a static grid — no JS required.
